/**
 * "Featured Toys" product carousel: advances one card at a time on a timer.
 * Scrolls the track directly instead of clicking Dawn's own "next" button
 * (global.js SliderComponent): that button gets a `disabled` attribute
 * whenever Dawn's geometry check (isSlideVisible) thinks the last card is
 * on screen, and calling .click() on a disabled button is a silent no-op
 * in every browser — the carousel would just stop advancing, and exactly
 * when that geometry check fires early enough to matter depends on the
 * viewport/card-count combination, so it only ever showed up on some
 * devices. Reading the step size fresh from the current card layout on
 * every tick keeps it correct across resizes without a resize listener.
 */
(function () {
  function initAutoplay(root) {
    var track = root.querySelector('[id^="Slider-"]');
    if (!track) return;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var interval = parseInt(root.getAttribute('data-autoplay-interval'), 10) || 4000;
    var timer = null;

    function stepSize() {
      var items = track.querySelectorAll('[id^="Slide-"]');
      if (items.length < 2) return track.clientWidth;
      return items[1].offsetLeft - items[0].offsetLeft;
    }

    function advance() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 0) return;
      if (track.scrollLeft >= maxScroll - 2) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        track.scrollTo({ left: Math.min(track.scrollLeft + stepSize(), maxScroll), behavior: 'smooth' });
      }
    }

    function play() {
      if (reducedMotion.matches) return;
      stop();
      timer = window.setInterval(advance, interval);
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', play);
    reducedMotion.addEventListener('change', function () {
      if (reducedMotion.matches) {
        stop();
      } else {
        play();
      }
    });

    play();
  }

  function init() {
    document.querySelectorAll('[data-autoplay].product-showcase__slider').forEach(initAutoplay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
